import { oc } from "@orpc/contract";
import { z } from "zod";

const FeedbackLabelSchema = z.object({
    id: z.string(),
    text: z.string()
});
export type FeedbackLabel = z.infer<typeof FeedbackLabelSchema>;

const FeedbackLabelsSchema = z.object({
    items: z.array(FeedbackLabelSchema)
});
export type FeedbackLabels = z.infer<typeof FeedbackLabelsSchema>;

const FeedbackMetricOptionSchema = z.object({
    id: z.string(),
    text: z.string()
});
export type FeedbackMetricOption = z.infer<typeof FeedbackMetricOptionSchema>;

const FeedbackMetricOptionsSchema = z.object({
    items: z.array(FeedbackMetricOptionSchema)
});
export type FeedbackMetricOptions = z.infer<typeof FeedbackMetricOptionsSchema>;

export const feedbackCatalogContract = {
    getLabels: oc.route({ method: "GET", path: "/labels" }).errors({ UPSTREAM_FAILURE: {} }).output(FeedbackLabelsSchema),
    getMetrics: oc.route({ method: "GET", path: "/metrics" }).errors({ UPSTREAM_FAILURE: {} }).output(FeedbackMetricOptionsSchema)
};
